import { render, staticRenderFns } from "./AxExpPanel.vue?vue&type=template&id=3872b24a&scoped=true&"
import script from "./AxExpPanel.vue?vue&type=script&lang=js&"
export * from "./AxExpPanel.vue?vue&type=script&lang=js&"
import style0 from "./AxExpPanel.vue?vue&type=style&index=0&id=3872b24a&lang=scss&scoped=true&"
import style1 from "./AxExpPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872b24a",
  null
  
)

export default component.exports